import { useTimelinePlayback } from "@/contexts/playback-context";
import { copyToClipboard } from "@/shared/helpers/copy-to-clipboard";
import { useViewSettings } from "@/view-settings";
import { observer, useSelector } from "@legendapp/state/react";
import dayjs from "dayjs";
import { twMerge } from "tailwind-merge";

export const CurrentTime = observer(function CurrentTimeObserver() {
  const viewSettings = useViewSettings();
  const timelinePlayback = useTimelinePlayback();
  const currentTime = timelinePlayback.currentTime.get();
  const historyStartTime = timelinePlayback.dateRange.start.get();
  const liveStartTime = timelinePlayback.liveMeta.start.get();
  const showAbsoluteTime = useSelector(() =>
    viewSettings.showAbsoluteTime.get()
  );

  const displayPlaybackTime = () => {
    if (!currentTime) return "00:00:00.0";

    if (showAbsoluteTime) {
      return dayjs(currentTime).toISOString();
    }

    if (historyStartTime) {
      return dayjs
        .duration(currentTime - historyStartTime.getTime())
        .format("HH:mm:ss.SSS")
        .substring(0, 10);
    } else if (liveStartTime) {
      return dayjs(currentTime).format("HH:mm:ss.SSS").substring(0, 10);
    }
  };

  const handleCopy = () => {
    if (!showAbsoluteTime) return;

    copyToClipboard(new Date(currentTime).toISOString());
  };

  return (
    <>
      <span
        className={twMerge([
          "text-brand-gray-200 slashed-zero tabular-nums select-none grow",
          showAbsoluteTime ? "min-w-[220px]" : "min-w-[100px]",
        ])}
        title={String(dayjs(currentTime).toISOString())}
        onClick={handleCopy}
      >
        {displayPlaybackTime()}
      </span>
    </>
  );
});
